<div class="mat-dialog-containers">
  <h4 mat-dialog-title class="mat-dialog-title">Solicitud</h4>
  <form [formGroup]="solicitudForm" class="form-container">
    <div class="row">
      <!-- Columna 1 -->
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="quienRadica"
            ><span class="required">*</span> ¿Quién radica?</label
          >
          <input
            type="text"
            class="form-control"
            id="quienRadica"
            formControlName="quienRadica"
            readonly
            placeholder="ASESOR"        
          />
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12"></div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="tipoDocumento"
            ><span class="required">*</span> Tipo Documento</label
          >
          <input
            type="text"
            class="form-control"
            id="tipoDocumento"
            formControlName="tipoDocumento"
            readonly
            maxlength="4"
          />
          <small
            class="text-danger"
            *ngIf="solicitudForm.get('tipoDocumento')?.hasError('required')"
          >
            Este campo es obligatorio
          </small>
          <small
            class="text-danger"
            *ngIf="solicitudForm.get('tipoDocumento')?.hasError('pattern')"
          >
            Solo letras, sin espacios, máximo 4 caracteres
          </small>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="documento"
            ><span class="required">*</span> Documento</label
          >
          <input
            type="text"
            class="form-control"
            id="documento"
            readonly
            formControlName="documento"
          />
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="nombres"><span class="required">*</span> Nombres</label>
          <input
            type="text"
            class="form-control"
            id="nombres"
            readonly
            formControlName="nombres"
          />
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="apellidos"
            ><span class="required">*</span> Apellidos</label
          >
          <input
            type="text"
            class="form-control"
            id="apellidos"
            readonly
            formControlName="apellidos"
          />
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="ciudad"><span class="required">*</span> Ciudad</label>
          <select
            class="form-control"
            id="ciudad"
            formControlName="ciudad"
            [ngClass]="{
              'is-invalid': solicitudForm.get('ciudad')?.invalid && solicitudForm.get('ciudad')?.touched
            }"
          >
            <option value="">--- Seleccione ----</option>
            <option *ngFor="let ciudad of ciudades" [value]="ciudad.partido">
              {{ ciudad.descripcion }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="solicitudForm.get('ciudad')?.hasError('required')">
            Este campo es obligatorio
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="celular"><span class="required">*</span> Celular</label>
          <input
            type="text"
            class="form-control"
            id="celular"
            formControlName="celular"
            [ngClass]="{
              'is-invalid': solicitudForm.get('celular')?.invalid && solicitudForm.get('celular')?.touched
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="solicitudForm.get('celular')?.hasError('required') && solicitudForm.get('celular')?.touched"
          >
            Este campo es obligatorio
          </div>
          <!-- Puedes agregar más validaciones si las usas -->
          <div
            class="invalid-feedback"
            *ngIf="solicitudForm.get('celular')?.hasError('pattern') && solicitudForm.get('celular')?.touched"
          >
            El número de celular no es válido
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="correo"><span class="required">*</span> Correo Electrónico</label>
          <input
            type="email"
            class="form-control"
            id="correo"
            formControlName="correo"
            [ngClass]="{
              'is-invalid': solicitudForm.get('correo')?.invalid && solicitudForm.get('correo')?.touched
            }"
          />
          <div class="invalid-feedback" *ngIf="solicitudForm.get('correo')?.hasError('required')">
            Este campo es obligatorio
          </div>
          <div class="invalid-feedback" *ngIf="solicitudForm.get('correo')?.hasError('pattern')">
            El correo no es válido
          </div>
          <div class="invalid-feedback" *ngIf="solicitudForm.get('correo')?.hasError('maxlength')">
            No puede tener más de 60 caracteres
          </div>
        </div>        
      </div>
      
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="institucion"><span class="required">*</span> Institución o Médico</label>
          <input
            type="text"
            class="form-control"
            id="institucion"
            formControlName="institucion"
            [ngClass]="{
              'is-invalid': solicitudForm.get('institucion')?.invalid && solicitudForm.get('institucion')?.touched
            }"
          />
          <div class="invalid-feedback" *ngIf="solicitudForm.get('institucion')?.hasError('required')">
            Este campo es obligatorio
          </div>
          <div class="invalid-feedback" *ngIf="solicitudForm.get('institucion')?.hasError('pattern')">
            Solo se permiten letras, números y espacios
          </div>
          <div class="invalid-feedback" *ngIf="solicitudForm.get('institucion')?.hasError('maxlength')">
            No puede tener más de 100 caracteres
          </div>
        </div>        
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12 full-width">
        <div class="form-group">
          <label for="observaciones"
                 >Observaciones</label
          >
          <textarea
            class="form-control"
            id="observaciones"
            formControlName="observaciones"
            rows="3"
            ></textarea>       
        </div>
      </div>
    </div>

    <h4 mat-dialog-title class="mat-dialog-title">Archivos Adjuntos</h4>

    <div class="mensaje-info">
      <p><strong>Apreciado (a) Asesor (a).</strong></p>
      <p>
        Recuerde que para el trámite de la solicitud debe adjuntar la
        <strong>orden médica</strong> e <strong>historia clínica</strong> del
        paciente.
      </p>
      <p>
        Valide que los campos obligatorios se encuentran diligenciados con los
        datos del paciente.
      </p>
      <p>
        Tenga en cuenta que si se radica una solicitud después de las
        <strong>4:00pm</strong>, la fecha de radicación quedará para el día
        siguiente.
      </p>
    </div>

    <ng-template #dialogFormatoInvalido>
      <div class="dialog-container">
        <div class="dialog-header">ERROR</div>
        <div class="dialog-content">
          <p>Tipo de archivo no válido</p>
          <button
            mat-button
            mat-dialog-close
            color="primary"
            class="custom-button"
          >
            Aceptar
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #dialogTamanioExcedido>
      <div class="dialog-container">
        <div class="dialog-header">ERROR</div>
        <div class="dialog-content">
          <p>El archivo supera el tamaño permitido de 20MB</p>
          <button
            mat-button
            mat-dialog-close
            color="primary"
            class="custom-button"
          >
            Aceptar
          </button>
        </div>
      </div>
    </ng-template>

    <div class="grupo-adjuntar">
      <label for="quienRadica"
        ><span class="required">*</span> Adjuntar Orden Medica</label
      >

      <div class="archivo-item">
        <button
          class="boton-subida"
          (click)="ordenMedicaInput.click()"
          (dragover)="onDragOver($event, 'ordenMedica')"
          (dragleave)="onDragLeave($event, 'ordenMedica')"
          (drop)="onDrop($event, 'ordenMedica')"
          [class.drag-hover]="isDragging['ordenMedica']"
        >
          <div class="contenido-boton">
            <mat-icon
              svgIcon="plus"
              style="height: 74px; width: 32px"
            ></mat-icon>
            <span style="width: calc(80% - 24px)">
              {{
                isDragging["ordenMedica"]
                  ? "Suelte aquí"
                  : "Arrastrar o seleccionar archivo"
              }}
            </span>
          </div>
        </button>

        <input
          type="file"
          #ordenMedicaInput
          multiple
          (change)="onFileSelected($event, 'ordenMedica')"
          hidden
        />

        <table *ngIf="archivos['ordenMedica']?.length" class="tabla-archivos">
          <thead>
            <tr>
              <th>Nombre Archivo</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let archivo of archivos['ordenMedica']; let i = index">
              <td>{{ archivo.name }}</td>
              <td class="acciones">
                <button
                  class="btn-eliminar"
                  (click)="eliminarArchivo('ordenMedica', i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="grupo-adjuntar">
      <label for="quienRadica"
        ><span class="required">*</span> Adjuntar Historia Clinica</label
      >

      <div class="archivo-item_2">
        <button
          class="boton-subida"
          (click)="historiaClinicaInput.click()"
          (dragover)="onDragOver($event, 'historiaClinica')"
          (dragleave)="onDragLeave($event, 'historiaClinica')"
          (drop)="onDrop($event, 'historiaClinica')"
          [class.drag-hover]="isDragging['historiaClinica']"
        >
          <div class="contenido-boton">
            <mat-icon
              svgIcon="plus"
              style="height: 74px; width: 32px"
            ></mat-icon>
            <span style="width: calc(80% - 24px)">
              {{
                isDragging["historiaClinica"]
                  ? "Suelte aquí"
                  : "Arrastrar o seleccionar archivo"
              }}
            </span>
          </div>
        </button>

        <input
          type="file"
          #historiaClinicaInput
          multiple
          (change)="onFileSelected($event, 'historiaClinica')"
          hidden
        />

        <table
          *ngIf="archivos['historiaClinica']?.length"
          class="tabla-archivos"
        >
          <thead>
            <tr>
              <th>Nombre Archivo</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let archivo of archivos['historiaClinica']; let i = index"
            >
              <td>{{ archivo.name }}</td>
              <td class="acciones">
                <button
                  class="btn-eliminar"
                  (click)="eliminarArchivo('historiaClinica', i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ng-template #dialogArchivoDuplicado>
      <div class="dialog-container">
        <div class="dialog-header">ERROR</div>
        <div class="dialog-content">
          <p>
            El archivo que está intentando agregar ya se encuentra cargado.
            Inténtelo de nuevo
          </p>
          <button
            mat-button
            mat-dialog-close
            color="primary"
            class="custom-button"
          >
            Aceptar
          </button>
        </div>
      </div>
    </ng-template>

    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        class="btn-save"
        (click)="guardarSolicitud()"
      >
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </div>

    <ng-template #dialogRadicadoExitoso let-data>
      <div class="dialog-container">
        <div class="dialog-header">Registro exitoso. Gracias por utilizar nuestro servicio</div>
        <div class="dialog-content">
          <p>
            Si desea hacer seguimiento a este registro puede hacerlo con la solicitud #
            <strong>{{ data?.numeroRadicado  }}</strong>     
          </p>
          <button mat-button (click)="cerrarDialogo()">Salir</button>
        </div>
      </div>
    </ng-template>

    <ng-template #dialogError let-data>
      <div class="dialog-container">
        <div class="dialog-header">Error al enviar la solicitud</div>
        <div class="dialog-content">
          <p>{{ data?.mensajeError }}</p>
          <button mat-button (click)="cerrarDialogo()">Cerrar</button>
        </div>
      </div>
    </ng-template>

    <ng-template #dialogCamposRequeridos>
      <div class="dialog-container">
        <div class="dialog-header">ERROR</div>
        <div class="dialog-content">
          <p>Por favor complete todos los campos requeridos</p>
          <button
            mat-button
            mat-dialog-close
            color="primary"
            class="custom-button"
          >
            Aceptar
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #dialogArchivosRequeridos>
      <div class="dialog-container">
        <div class="dialog-header">ERROR</div>
        <div class="dialog-content">
          <p>Por favor adjunte los archivos requeridos</p>
          <button
            mat-button
            mat-dialog-close
            color="primary"
            class="custom-button"
          >
            Aceptar
          </button>
        </div>
      </div>
    </ng-template>
  </form>
</div>
